import React, { useState } from 'react';
import { ModalType } from '../types';
import { LEGAL_URLS } from '../config/legal';
import { useLogout } from '../hooks/useLogout';

interface SettingsDropdownProps {
  openModal: (type: ModalType) => void;
  onLogout?: () => void;
  setActiveView?: (view: string) => void;
}

export const SettingsDropdown: React.FC<SettingsDropdownProps> = ({ openModal, onLogout, setActiveView }) => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { logout, forceLogout } = useLogout();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      // Use the improved logout hook which handles Clerk session cleanup
      const success = await logout({ 
        clearAllSessions: false, // Only logout from current session
        redirectTo: undefined // Don't redirect, let parent handle it
      });
      
      if (!success) {
        // If normal logout failed, try force logout
        console.warn('Normal logout failed, attempting force logout...');
        await forceLogout();
      }
      
      // Call parent logout handler if provided
      if (onLogout) {
        onLogout();
      }
    } catch (error) {
      console.error('Error during logout:', error);
      // Even on error, try force logout to ensure cleanup
      try {
        await forceLogout();
      } catch (forceError) {
        console.error('Force logout also failed:', forceError);
      }
      
      // Still call parent handler
      if (onLogout) {
        onLogout();
      }
    } finally {
      setIsLoggingOut(false);
    }
  };
  return (
    <div className="absolute top-full right-0 mt-2 w-56 rounded-xl bg-white shadow-lg z-10 p-2 flex flex-col items-start">
      {/* <button 
        onClick={() => setActiveView ? setActiveView('about-us') : window.open('/about', '_blank')}
        className="w-full text-left h-10 px-2 py-2 flex items-center rounded-lg hover:bg-gray-100 text-grayscale-1300 font-grotesk text-sm"
      >
        About Us
      </button> */}
      <button 
        onClick={() => setActiveView ? setActiveView('terms-of-service') : window.open(LEGAL_URLS.TERMS_OF_SERVICE, '_blank')}
        className="w-full text-left h-10 px-2 py-2 flex items-center rounded-lg hover:bg-gray-100 text-grayscale-1300 font-grotesk text-sm"
      >
        Terms of service
      </button>
      <button 
        onClick={() => setActiveView ? setActiveView('privacy-policy') : window.open(LEGAL_URLS.PRIVACY_POLICY, '_blank')}
        className="w-full text-left h-10 px-2 py-2 flex items-center rounded-lg hover:bg-gray-100 text-grayscale-1300 font-grotesk text-sm"
      >
        Privacy Policy
      </button>
      <button onClick={() => openModal(ModalType.ChangePassword)} className="w-full text-left h-10 px-2 py-2 flex items-center rounded-lg hover:bg-gray-100 text-grayscale-1300 font-grotesk text-sm">
        Change password
      </button>
      <button onClick={() => openModal(ModalType.DeleteAccount)} className="w-full text-left h-10 px-2 py-2 flex items-center rounded-lg hover:bg-gray-100 text-grayscale-1300 font-grotesk text-sm">
        Delete Account
      </button>
      <button 
        onClick={handleLogout}
        disabled={isLoggingOut}
        className="w-full text-left h-10 px-2 py-2 flex items-center rounded-lg hover:bg-gray-100 text-grayscale-1300 font-grotesk text-sm disabled:opacity-50"
      >
        {isLoggingOut ? 'Logging out...' : 'Logout'}
      </button>
    </div>
  );
};
